import React from "react";
import { Outlet, NavLink, Navigate, Link, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { LayoutGrid, Package, Mail, LogOut, ExternalLink, Loader2 } from "lucide-react";

const NAV = [
  { to: "/admin", end: true, label: "Tableau de bord", icon: LayoutGrid },
  { to: "/admin/products", label: "Produits", icon: Package },
  { to: "/admin/messages", label: "Messages", icon: Mail },
];

const AdminLayout = () => {
  const { user, logout } = useAuth();
  const location = useLocation();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#050505]">
        <Loader2 className="text-[#C5A059] animate-spin" />
      </div>
    );
  }
  if (!user || user.role !== "admin") {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }

  return (
    <div data-testid="admin-layout" className="min-h-screen bg-[#050505] flex">
      {/* Sidebar */}
      <aside className="w-64 bg-[#0a0a0a] border-r border-white/5 flex flex-col fixed h-screen">
        <div className="p-6 border-b border-white/5">
          <Link to="/admin" className="block">
            <img
              src="https://customer-assets.emergentagent.com/job_sneaker-hub-242/artifacts/44serdge_Suzel%20gold.png"
              alt="Suzel Holding"
              className="h-20 w-auto mx-auto mb-3"
              data-testid="admin-sidebar-logo"
            />
            <p className="overline text-center">Admin</p>
          </Link>
        </div>

        <nav className="flex-1 p-4 space-y-1">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                data-testid={`admin-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-4 py-3 text-sm transition-colors ${
                    isActive
                      ? "bg-[#C5A059]/10 text-[#C5A059] border-l-2 border-[#C5A059]"
                      : "text-white/70 hover:text-white hover:bg-white/5"
                  }`
                }
              >
                <Icon size={16} strokeWidth={1.6} />
                {n.label}
              </NavLink>
            );
          })}
        </nav>

        <div className="p-4 border-t border-white/5 space-y-2">
          <a
            href="/"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="admin-view-site"
            className="flex items-center gap-3 px-4 py-3 text-sm text-white/60 hover:text-[#C5A059] transition-colors"
          >
            <ExternalLink size={16} /> Voir le site
          </a>
          <div className="px-4 py-3">
            <p className="text-xs text-white/40 mb-1">Connecté en tant que</p>
            <p className="text-sm text-white truncate">{user.email}</p>
          </div>
          <button
            onClick={logout}
            data-testid="admin-logout-button"
            className="w-full flex items-center gap-3 px-4 py-3 text-sm text-white/70 hover:text-red-400 transition-colors"
          >
            <LogOut size={16} /> Déconnexion
          </button>
        </div>
      </aside>

      {/* Content */}
      <main className="flex-1 ml-64 p-10">
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
